import { render, staticRenderFns } from "./SettingsSection.vue?vue&type=template&id=3835f336&scoped=true"
import script from "./SettingsSection.vue?vue&type=script&lang=js"
export * from "./SettingsSection.vue?vue&type=script&lang=js"
import style0 from "./SettingsSection.vue?vue&type=style&index=0&id=3835f336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835f336",
  null
  
)

export default component.exports